import { Fragment } from 'prosemirror-model'

/*
 * Serialize a fragment to a plain text string.
 * The returned string is created by concatenation of the text content of each node.
 * When fragment is not given, an empty string is returned instead.
 */
export const serializeFragmentToPlainTextString = (fragment?: Fragment): string => {
  if (!fragment) {
    return ''
  }
  let textContents: string[] = []
  fragment.forEach((node) => {
    textContents.push(node.textContent)
  })
  return textContents.join(' ').trim()
}
